export default {
    inspectionList: [],
    inspectionReportState: null
}



// WEBPACK FOOTER //
// ./src/modules/inspection-report/state.js